import { render, staticRenderFns } from "./seat.vue?vue&type=template&id=56e8e6d9&scoped=true"
import script from "./seat.vue?vue&type=script&lang=js"
export * from "./seat.vue?vue&type=script&lang=js"
import style0 from "./seat.vue?vue&type=style&index=0&id=56e8e6d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8e6d9",
  null
  
)

export default component.exports